import StepsProcess from '@/components/common/ui/HowWeWork/HowWeWork';
import { Layout, FileEdit, Megaphone, LayoutDashboard, Sparkles } from "lucide-react";

export default function HowToCreateWebsite() {
    const steps = [
        { 
            icon: Layout, 
            label: 'Pick a Template',
            description: 'Choose from 100+ designs'
        },
        { 
            icon: FileEdit, 
            label: 'Add Your Content',
            description: 'Customize and personalize'
        },
        { 
            icon: Megaphone, 
            label: 'Built-in Marketing',
            description: 'Reach your audience'
        },
        { 
            icon: LayoutDashboard, 
            label: 'Manage Everything',
            description: 'One dashboard control'
        },
        { 
            icon: Sparkles, 
            label: 'Premium Features',
            description: 'Scale as you grow'
        }
    ];

    return (
        <section className="relative w-full pb-20 lg:pb-24">
            <div className="container">

                {/* How We Work Visual Section */}
                <div className="mt-24">
                    <h2 className="text-white font-bold text-3xl md:text-4xl leading-tight mb-16 text-center">
                        How We Work
                    </h2>
                    <StepsProcess steps={steps} />
                </div>
            </div>
        </section>
    );
}